import { render } from "./CustomDailogue.vue?vue&type=template&id=54c44628&ts=true"
import script from "./CustomDailogue.vue?vue&type=script&lang=ts"
export * from "./CustomDailogue.vue?vue&type=script&lang=ts"

import "./CustomDailogue.vue?vue&type=style&index=0&id=54c44628&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__